import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { destinationFor } from '../hrms/utils/notificationRouting';

export function TaskDetailRoute({ children }: { children: ReactNode }) {
  const { id = '' } = useParams<{ id: string }>();
  const destination = destinationFor('', id);

  if (destination !== `/tasks/${id}`) {
    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
}
